import * as React from 'react';
import { Row, HorizontalAlign, VerticalAlign } from 'common--design-library';
import classnames from 'classnames';

export interface ITableRowProps {
    children: React.ReactNode | React.ReactNode[];
    selected?: boolean;
    className?: string;
    horizontalAlign?: HorizontalAlign;
    verticalAlign?: VerticalAlign;
    roleForTest?: string;

    onClick?: () => void;
}

export const TableRow: React.FC<ITableRowProps> = props => {
    return (
        <Row
            horizontalAlign={props.horizontalAlign ? props.horizontalAlign : "center"}
            verticalAlign={props.verticalAlign ? props.verticalAlign : 'start'}
            onClick={props.onClick}
            className={classnames('grid-table-row', { selectable: !!props.onClick }, { selected: props.selected }, props.className)}
            data-test-role={props.roleForTest}
        >
            {props.children}
        </Row>
    );
};
